import { render, staticRenderFns } from "./PavilionGroup.vue?vue&type=template&id=62f3d612&scoped=true&"
import script from "./PavilionGroup.vue?vue&type=script&lang=ts&"
export * from "./PavilionGroup.vue?vue&type=script&lang=ts&"
import style0 from "./PavilionGroup.vue?vue&type=style&index=0&id=62f3d612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f3d612",
  null
  
)

export default component.exports